import src from "IMAGE";
export default { src, width: 360, height: 57, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AFMmyP9CIKj/RSWl/0Eio/8+IKL/PiGj/0Uks/9MJ8H/CJ0Qq1wdu4MAAAAASUVORK5CYII="};
